{
  "hero": {
    "title": "Stories that need to be heard",
    "subtitle": "Independent journalism in French, English, and Arabic"
  },
  "latest": {
    "title": "Latest Stories",
    "viewAll": "View all articles",
    "backHome": "Back to homepage",
    "emptyTitle": "Stories are on their way",
    "emptyText": "We're preparing our first stories — check back soon."
  },
  "categories": {
    "all": "All",
    "investigation": "Investigations",
    "culture": "Culture",
    "opinion": "Opinion",
    "features": "Features",
    "video": "Video"
  },
  "newsletter": {
    "title": "Stay informed",
    "description": "Get the latest stories delivered to your inbox.",
    "placeholder": "Your email address",
    "cta": "Subscribe",
    "success": "Thank you for subscribing!",
    "error": "Subscription failed. Please try again."
  },
  "about": {
    "title": "About Beyond Silence",
    "p1": "Beyond Silence is an independent trilingual journalism platform publishing in French, English, and Arabic. We believe that stories from every community deserve to be heard — not silenced, not ignored, not lost in translation.",
    "p2": "Our team of journalists, editors, and contributors works across borders to bring you investigations, features, opinion pieces, and video reporting that challenge the status quo and amplify underrepresented voices.",
    "p3": "Beyond Silence is funded by readers like you. We do not run a paywall or require a subscription. If you value our work, consider supporting us through Buy Me a Coffee — every contribution helps us keep reporting.",
    "contactTitle": "Get in touch",
    "contactDesc": "Have a story tip, want to collaborate, or interested in joining our team? Reach out to us at contact@beyondsilence.fr. We read every message."
  },
  "contact": {
    "title": "Contact us",
    "description": "Questions, story tips, or collaboration ideas? Write to us — we read every message."
  }
}
